var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-start tw-gap-1 tw-rounded tw-bg-light-gray tw-p-2 tw-text-dark-gray"},[_c('v-icon',{staticClass:"-tw-mt-px tw-text-base"},[_vm._v("mdi-alert-circle")]),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }